import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { first } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-mi-challan',
  templateUrl: './mi-challan.component.html',
  styleUrls: ['./mi-challan.component.scss']
})
export class MiChallanComponent implements OnInit {

  public filteredAppId: any;
  public farmerMobile: any;
  public farmerId: any;
  public farmerAppDetails: any;
  public selectedAppId: any;
  public selectedFarmerDeatils: any;
  public famerAppDetailsforDropDown: any = [];

  public showFarmerShareChallan: boolean = false;
  public showFullPaymentChallan: boolean = false;
  public showSanctionLetter: boolean = false;
  
  constructor(
    public router: Router,
    public dashboard: DashboardService,
    public productService: BankDetailService, 
    public challanMIService: ChallanService,
    private messageService: MessageService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService, 
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    this.farmerMobile = farmerConfData.get('farmerPh');
    
    let farmerData = farmerConfData.get('farmerDetails');

    let farmerId = farmerConfData.get('Farmer_Id_');
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    this.getApplicationIdsForChallan(farmerId)
  }

  getApplicationIdsForChallan(farmerId) {
    let mobile = this.farmerMobile

    let reqBody = {
      FarmerId: farmerId,
      WindowType: "Challan"
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.challanMIService
      .getApplicationIdsForChallan(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resData) => {
          let res = JSON.parse(this.cryptoJsService.DecryptToken(resData.data));
          // this.activityRecordService.activityRecord(mobile, 'MI Challan', farmerId, new Date(), 'Success');
     
          this.farmerAppDetails = res;
          this.loader.close();
          // this.farmerAppDetails.map(val => {
          //   this.famerAppDetailsforDropDown.push({ 
          //     AppId: val.AppId.concat(" (" ,val.ProgramId, ")"),
          //     ProgramId: val.ProgramId,
          //     ChallanStatus: val.ChallanStatus
          //   })
          // })
          if (this.farmerAppDetails.length > 0) {
            this.famerAppDetailsforDropDown = this.farmerAppDetails.map(res => {
              return {
                appIdToDisplay: res.AppId + ' ('+ res.ProgrammeName + ')',
              ...res
             }
            })
          }
        },
        error: (err) => {
          // this.activityRecordService.activityRecord(mobile, 'MI Challan', farmerId, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onFarmerShareClick(){
    this.showFarmerShareChallan = true;
    // this.router.navigate([`farmer/challan/farmer-share/${this.selectedAppId.AppId}/${this.selectedAppId.ProgID}`]);
  }

  onFullPaymentClick(){
    this.showFullPaymentChallan = true;
    // this.router.navigate([`farmer/challan/full-payment/${this.selectedAppId.AppId}/${this.selectedAppId.ProgID}`]);
  }

  onSanctionLetterClick(){
    this.showSanctionLetter = true;
    // this.router.navigate([`farmer/challan/sanction-letter/${this.selectedAppId.AppId}/${this.selectedAppId.ProgID}`]);
  }

  onSelectAppId(){
    this.selectedAppId = this.selectedFarmerDeatils;
  }

}
